import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from 'react-simple-maps';
import { geoCentroid } from 'd3-geo';

import countiesGeo from '../../../data/countiesGeo.json';

function getAnchorPosition(county) {
  switch (county) {
    case 'Westchester':
      return 'start';
    case 'Rockland':
      return 'end';
    default:
      return 'middle';
  }
}

export default function MapBase({ countyData }) {
  return (
    <ComposableMap
      projection='geoMercator'
      projectionConfig={{
        scale: 15000,
        center: [-74.25, 41.55],
      }}
      width={500}
      height={450}
      style={{
        width: '100%',
        height: '100%',
        display: 'block',
      }}
    >
      <Geographies geography={countiesGeo}>
        {({ geographies }) =>
          geographies.map((geo) => {
            const countyName = geo.properties.NAME;
            const { color, value } = countyData[countyName];

            const centroid = geoCentroid(geo);

            return (
              <g key={geo.rsmKey}>
                <Geography
                  geography={geo}
                  fill={value === 0 ? 'gray' : color}
                  stroke='#ffffff'
                  strokeWidth={1}
                  style={{
                    default: {
                      outline: 'none',
                    },
                    hover: {
                      fill: color,
                      opacity: 0.8,
                      outline: 'none',
                    },
                    pressed: {
                      outline: 'none',
                    },
                  }}
                  aria-label={`${countyName}: ${value}`}
                />

                <Marker coordinates={centroid}>
                  <text
                    textAnchor={getAnchorPosition(countyName)}
                    dominantBaseline='central'
                    style={{
                      fontFamily: 'system-ui, sans-serif',
                      fontSize: 12,
                      fontWeight: 400,
                      fill: 'black',
                      pointerEvents: 'none',
                    }}
                  >
                    <tspan
                      x='0'
                      dy='-0.6em'
                    >
                      {countyName}
                    </tspan>
                    {value > 0 && (
                      <tspan
                        x='0'
                        dy='1.2em'
                      >
                        {value}
                      </tspan>
                    )}
                  </text>
                </Marker>
              </g>
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
}
